import { useEffect, useState } from "react";

const navLinks = [
  { label: "热度榜", href: "#rank" },
  { label: "快讯流", href: "#feed" },
  { label: "深挖材料", href: "#materials" },
  { label: "入口导航", href: "#entries" },
  { label: "跟进爆料", href: "#follow" },
];

export default function SiteNav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/95 backdrop-blur"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="flex h-16 items-center justify-between px-4 md:h-20 md:px-8 lg:px-12">
        <a href="#top" className="flex cursor-pointer items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black text-background-50">
            料
          </span>
          <span
            className={`font-heading text-xl font-black tracking-tight md:text-2xl ${
              scrolled ? "text-foreground-950" : "text-background-50"
            }`}
          >
            黑料bu
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap text-sm font-medium transition-colors ${
                scrolled
                  ? "text-foreground-600 hover:text-primary-600"
                  : "text-background-100/90 hover:text-background-50"
              }`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#feed"
            className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            直达爆料
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          aria-label="打开菜单"
          className={`flex h-10 w-10 cursor-pointer items-center justify-center md:hidden ${
            scrolled ? "text-foreground-900" : "text-background-50"
          }`}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </nav>

      {open ? (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between border-b border-background-100 py-3.5 text-sm font-medium text-foreground-800 transition-colors hover:text-primary-600"
              >
                {link.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-300"></i>
              </a>
            ))}
            <a
              href="#feed"
              onClick={() => setOpen(false)}
              className="mt-4 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-center text-sm font-semibold text-background-50"
            >
              直达爆料
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}